import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaShoppingCart, FaArrowLeft, FaCheck } from 'react-icons/fa';
import { useCart } from '../../context/CartContext';
import styles from './ProductDetails.module.css';
import { products } from '../../data/products';

const ProductDetails = () => {
  const { id } = useParams();
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const { addToCart } = useCart();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const product = products.find(p => p.id === parseInt(id));

  if (!product) {
    return <div className={styles.notFound}>Product not found</div>;
  }

  const handleAddToCart = () => {
    addToCart(product, quantity);
  };

  return (
    <div className={styles.productDetails}>
      <div className="container">
        <Link to="/products" className={styles.backLink}>
          <FaArrowLeft /> Back to Products
        </Link>

        <div className={styles.productContainer}>
          {/* Left Side - Images */}
          <div className={styles.imageSection}>
            <motion.div
              className={styles.mainImage}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <img src={product.images[selectedImage]} alt={product.name} />
            </motion.div>

            <div className={styles.thumbnails}>
              {product.images.map((image, index) => (
                <div
                  key={index}
                  className={`${styles.thumbnail} ${selectedImage === index ? styles.activeThumbnail : ''}`}
                  onClick={() => setSelectedImage(index)}
                >
                  <img src={image} alt={`${product.name} ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>

          {/* Right Side - Details */}
          <div className={styles.detailsSection}>
            {product.popular && (
              <div className={styles.popularBadge}>⭐ Most Popular</div>
            )}

            <h1 className={styles.productName}>{product.name}</h1>
            <p className={`${styles.gujaratiName} gujarati-text`}>{product.gujarati}</p>

            <div className={styles.priceSection}>
              <span className={styles.price}>₹{product.price}</span>
              <span className={styles.size}>/ {product.size}</span>
            </div>

            <p className={styles.description}>{product.description}</p>

            <div className={styles.features}>
              <h3>Key Features:</h3>
              <ul>
                {product.features.map((feature, index) => (
                  <li key={index}>
                    <FaCheck /> {feature}
                  </li>
                ))}
              </ul>
            </div>

            <div className={styles.benefits}>
              <h3>Health Benefits:</h3>
              <ul>
                {product.benefits.map((benefit, index) => (
                  <li key={index}>
                    <FaCheck /> {benefit}
                  </li>
                ))}
              </ul>
            </div>

            <div className={styles.quantitySection}>
              <label>Quantity:</label>
              <div className={styles.quantityControls}>
                <button onClick={() => setQuantity(Math.max(1, quantity - 1))}>-</button>
                <span>{quantity}</span>
                <button onClick={() => setQuantity(quantity + 1)}>+</button>
              </div>
            </div>

            <div className={styles.totalPrice}>
              <span>Total:</span>
              <span className={styles.total}>₹{product.price * quantity}</span>
            </div>

            <button className={styles.addToCartBtn} onClick={handleAddToCart}>
              <FaShoppingCart /> Add to Cart
            </button>

            <div className={styles.guarantees}>
              <div className={styles.guarantee}>
                <span>✓</span> 100% Natural & Pure
              </div>
              <div className={styles.guarantee}>
                <span>✓</span> Free Delivery on Orders Above ₹1000
              </div>
              <div className={styles.guarantee}>
                <span>✓</span> COD Available
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;

